import {
  Badge,
  Breadcrumb,
  Checkbox,
  Col,
  Divider,
  Dropdown,
  Empty,
  Form,
  Input,
  Menu,
  Modal,
  notification,
  Popconfirm,
  Popover,
  Radio,
  RadioChangeEvent,
  Row,
  Select, Space,
  Spin,
  Table,
  Tabs,
  Tag,
  Tooltip
} from "antd";
import Button from "antd/es/button";
import { DeviceDetailApps } from "./device.detail.apps";
import { MacDeviceDetailApps } from "./device.detail.macApps";
import { DeviceDetailCertificate } from "./device.detail.certificate";
import DeviceDetailOperations from "./device.detail.operations";
// import { DeviceDetailEnrollInfo } from "./device.detail.enrollInfo";
import { DownOutlined, LoadingOutlined } from "@ant-design/icons";
import { useEffect, useRef, useState } from "react";
import { useHistory, useLocation, useParams } from "react-router";
import { Link } from 'react-router-dom';
import { getAllIosApps, getAndroidDeviceApps,getAllMacApps } from "../../axios/api.app";
import {
  androidDeviceOperation,
  applyAndroidTemplate,
  bypassActivationlock,
  deleteDevice,
  getDeviceAppList,
  getDeviceApps,
  getDeviceInfo,
  getDeviceProfiles,
  getTemplateListAll,
  installEnterprise,
  iosDeviceOperation,
  macDeviceOperation,
  openLock,
  iosDeviceDisenroll,
  getDeviceBypassCode,
  disown,
  getMacDeviceApps,
  getMacDeviceAppList,
  getMacDeviceManagedAppList
} from "../../axios/api.device";
import { stringContaint } from "../../utils/common";
import { gaEvent } from "../../withTracker";
import { LeaseListPage } from "../lease/lease.list";
import { DeviceDetailContents } from "./device.detail.contents";
import { DeviceDetailOverview } from "./device.detail.overview";
import { DeviceDetailProfiles } from "./device.detail.profiles";

import { RootStoreModel } from "@redux/reducers";
import { useSelector } from "react-redux";

import TextArea from "antd/lib/input/TextArea";
import { useTranslation } from "react-i18next";
import { DeviceDetailRestrictions } from "./device.detail.restrictions";
// import DeviceDetailPendings from "./device.detail.pendings";
import "./device.scss";
import { platform } from "os";

const { Item, List } = Form;
const { TabPane } = Tabs;

export const DeviceDetailList = () => {
  const routeParams: any = useParams();
  const routeLocation: any = useLocation();
  const history = useHistory()
  const [deviceId, setDeviceId] = useState<string>(routeParams?.id);
  const [data, setData] = useState<any>();
  const opsRef = useRef<any>();
  const [form] = Form.useForm();
  const [loding, setLoding] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isSingleAppVisible, setSingleAppVisible] = useState<boolean>(false);
  const [ActivationlockVisible, setActivationlockVisible] = useState<boolean>(false);
  const [clearDeviceVisible, setClearDeviceVisible] = useState<boolean>(false);
  const [optionDeviceVisible, setOptionDeviceVisible] = useState<boolean>(false);
  const [systemUpdateVisible, setSystemUpdateVisible] = useState<boolean>(false);
  const [clearLock, setClearLock] = useState<boolean>(false);
  const [resetDevice, setResetDevice] = useState<boolean>(false);
  const [installedAppsCount, setInstalledAppsCount] = useState<number>(0);
  const [configFilesCount, setConfigFilesCount] = useState<number>(0);
  // const [deviceStatus, setDeviceStatus] = useState<number>(routeLocation.state.status ?? 0);
  const [deviceStatus, setDeviceStatus] = useState<number>(0);

  const [isLockVisible, setIsLockVisible] = useState(false);
  
  const [selectPackage, setSelectPackage] = useState<string>();
  const [operationKey, setOperationKey] = useState(String);
  const [installApps, setInstallApps] = useState<any[]>();
  const [currentInstallApps, setCurrentInstallApps] = useState<any[]>();
  const [unInstallApps, setUnInstallApps] = useState<any[]>();
  const [unInstallVppApps, setUnInstallVppApps] = useState<any[]>();
  const [unInstallAppsSearch, setUnInstallAppsSearch] = useState<any[]>();
  const [isLoseModaVisible, setIsLoseModaVisible] = useState<boolean>(false);
  const [templateList, setTemplatList] = useState<any[]>([]);
  const [templateSearchList, setTemplateSearchList] = useState<any[]>([]);
  const [showTemplate, setShowTemplate] = useState<boolean>(false);
  const [selectTemplate, setSelectTemplate] = useState<string>("");
  const [bypassCode, setBypassCode] = useState<string>("");
  const [selectOpenKeys, setSelectOpenKeys] = useState<any[]>();
  const [dropdownVisible, setDropdownVisible] = useState<boolean>(false);
  const user = useSelector((state: RootStoreModel) => state.userState);
  const [autoEnable, setAutoEnable] = useState<boolean>(false);
  const { t } = useTranslation();
  const [isDisabled, setIsDisabled] = useState<boolean>(false);
  const [isMacModalVisible, setIsMacModalVisible] = useState(false);
  const [macForm] = Form.useForm();
  const [appType, setAppType] = useState<string>('AppStore');
  //const [isSingleAppMode,setIsSingleAppMode] = useState<boolean>(false);
  const columns = [
    // {
    //   title: '图标',
    //   dataIndex: 'appName',
    //   filterMultiple:false,
    //   key:"logoUrl",
    //   render: (logoUrl:any) => <Image  width={50} height={50} src={logoUrl}></Image>
    // },
    {
      title: '应用名称',
      dataIndex: 'appName',
      filterMultiple: false,
      key: 'appName',
    },
    {
      title: '包名',
      dataIndex: 'packageName',
      key: 'packageName',
    },
    {
      title: '版本',
      dataIndex: 'appVersion',
      key: 'appVersion',
    },
  ];

  const templateColumns = [

    {
      title: '配置文件名称',
      dataIndex: 'name',
      filterMultiple: false,
      key: 'name',
    },
    {
      title: '平台',
      dataIndex: 'platform',
      key: 'platform',
      render: (v: string) => {return v === "IOS" ? "iOS" : v}
    },
    {
      title: '创建时间',
      dataIndex: 'createTime',
      key: 'createTime',
    },
    // {
    //   title: '关联设备',
    //   dataIndex: 'deviceCount',
    //   key: 'deviceCount',
    // },
  ];

  function isVersionGreaterThan(version1: string, version2: string) {
    const v1 = version1.split('.').map(Number);
    const v2 = version2.split('.').map(Number);

    const len = Math.max(v1.length, v2.length);
    for (let i = 0; i < len; i++) {
      const a = v1[i] || 0;
      const b = v2[i] || 0;
      if (a > b) return true;
      if (a < b) return false;
    }
    return false;
  }

  useEffect(() => {
    if (deviceId) {
      getDeviceInfo(deviceId).then((res) => { 
        setData(res);
        if(res.platform == 'IOS' && !isVersionGreaterThan(res.osVersion,'17.0'))
          setIsDisabled(true);
        if(res.platform == 'macOS')
          setIsDisabled(true);
        setDeviceStatus(res.status);
        getOptions(res.platform, res.deviceType);
        getDeviceAppsData(res.platform);
        getDeviceProfilesData();
      });
    }
  }, []);

  const getOptions = (platform: string, deviceType: string) => {    
    if (platform == "IOS") {
      Promise.all([getDeviceAppList(deviceId), getAllIosApps({deviceType: deviceType })]).then(([res1, res2]) => {
        var insList = [];
        for (var i = 0; i < res2.length; i++) {
          var item = res2[i];
          insList.push({
            appId: item.isEnterpriseApp ? item.appId + `&enterprise${item.extension}` : item.adamId + "&store",
            name: item.isEnterpriseApp ? item.name + "--企业" : item.name,
            isEnterpriseApp: item.isEnterpriseApp,
          })
        }
        
        setInstallApps(insList);
        setUnInstallApps(res1);
      });
      getTemplateListAll().then(res => {
        res = res.filter((c: any) => {
          return c.platform == platform
        })
        setTemplateSearchList(res);
        setTemplatList(res);
      })

    } else if(platform == "macOS") {
      Promise.all([getMacDeviceAppList(deviceId), getAllMacApps(), getMacDeviceManagedAppList(deviceId)]).then(([res1, res2, res3]) => {
        var insList = [];
        for (var i = 0; i < res2.length; i++) {
          var item = res2[i];
          insList.push({
            appId: item.appId,
            name: item.appName,
            //name: item.appType == 'EnterpriseApp' ? item.appName + "--企业应用" : item.appType == 'LocalApp' ? item.appName + "--本地应用" : item.appName,
            appType: item.appType,
          })
        }
        
        setInstallApps(insList);
        setUnInstallApps(res1);
        setUnInstallVppApps(res3);

        var res = insList?.filter((c: any) => {
          return c.appType == 'AppStore'
        });
        setCurrentInstallApps(res);
        });

      getTemplateListAll().then(res => {
        res = res.filter((c: any) => {
          return c.platform == platform
        })
        setTemplateSearchList(res);
        setTemplatList(res);
      })
    } else {
        Promise.all([getDeviceAppList(deviceId), getAndroidDeviceApps({ deviceId: deviceId })]).then(([res1, res2]) => {
          console.log("获取app列表",res1, res2)
          setUnInstallApps(res1);
          if (res2.isSuccess) {
            setInstallApps(res2.data);
          }

        });
        getTemplateListAll().then(res => {
          res = res.filter((c: any) => {
            return c.platform == "Android"

          })
          setTemplateSearchList(res);
          setTemplatList(res);
      })
    }
  };
  const updateTags = ((param: string[]) => {
    var submitObj = document.getElementById('tag') as HTMLElement;
    submitObj.innerHTML = param.join("，");// param.toString();
  });
  const onSearch = (value: string) => {
    var arr = unInstallApps?.filter(c => {
      return stringContaint(value, c.appName);
    })
    setUnInstallAppsSearch(arr);
  }
  const onSearchTemplate = (value: string) => {
    var arr = templateList?.filter(c => {
      return stringContaint(value, c.name);
    })
    setTemplateSearchList(arr);
  }
  const deviceOps = (e: any) => {
    if (!e.key) {
      return
    }
    setDropdownVisible(false);
    setSelectOpenKeys([]);
    if (data?.platform == "IOS" || data?.platform == "macOS") {
      if (e.key == 'Lock') {
        if (data?.platform == "macOS") {
          setIsLockVisible(true);
          opsRef.current?.opsList();
        } else {
          iosDeviceOperation(deviceId, { commandType: 1, appId: 0 }).then(() => {
            notification.success({ message: t("操作成功") });
            opsRef.current?.opsList();
          })
        }
      } else if (e.key == 'Sync') {
        iosDeviceOperation(deviceId, {
          commandType: 0,
          appId: 0,
        }).then(() => {
          notification.success({ message: t("操作成功") });
          opsRef.current?.opsList();
          var timer = setInterval(function () {
            getOptions(data?.platform, data?.deviceType)
            window.location.reload();
            clearInterval(timer);
          }, 3000);
        })
      } else if (e.key == 'Install') {
        setOperationKey(e.key);
        if(data?.platform == 'macOS')
          setIsMacModalVisible(true)
        else
          setIsModalVisible(true);
      } else if (e.key == 'UnInstall') {
        setOperationKey(e.key);
        setIsModalVisible(true);
      } else if (e.key == 'RemoveInstallApp') {
        setOperationKey(e.key);
        setIsMacModalVisible(true)
      } else if (e.key == 'RemoveVppApp') {
        setOperationKey(e.key);
        setIsMacModalVisible(true)
      } else if (e.key == 'openSingleApp') {
        setUnInstallAppsSearch(unInstallApps);
        setSingleAppVisible(true);
      } else if (e.key == 'closeSingleApp') {
        iosDeviceOperation(deviceId, {
          commandType: 5,
          bundleId: selectPackage,
        }).then(() => {
          notification.success({ message: t("指令已发送,请稍后刷新页面") });
          var timer = setInterval(function () {
            getDeviceInfo(deviceId).then((res) => {
              setData(res);
              opsRef.current?.opsList();
            });
            clearInterval(timer);
          }, 3000);
          setSelectPackage("");
        })
        // if (data?.isSingleAppModeEnabled) {
        // } 
        // else {
        //   setUnInstallAppsSearch(unInstallApps);
        //   setSingleAppVisible(true);
        // }
      } else if (e.key == 'Location') {
        iosDeviceOperation(deviceId, {
          commandType: 7
        }).then(() => {
          opsRef.current?.opsList();
          notification.success({ message: t("操作成功") });
        }, () => {
          notification.error({ message: t("操作失败") });
        })
      } else if (e.key == 'openLostPattern') {
        setIsLoseModaVisible(true);
        opsRef.current?.opsList();
      } else if (e.key == 'closeLostPattern') {
        iosDeviceOperation(deviceId, {
          commandType: 9,
          message: "设备已丢失"
        }).then(() => {
            notification.success({ message: t("操作成功") });
            var timer = setInterval(function () {
              getDeviceInfo(deviceId).then((res) => {
                setData(res);
                opsRef.current?.opsList();
              });
              clearInterval(timer);
            }, 3000);
          }, () => {
            notification.error({ message: t("操作失败") });
          }
        )
        // if (data?.iosDeviceInfo?.isMDMLostModeEnabled) {
        // }
        // else {
        //   setIsLoseModaVisible(true);
        // }
      } else if (e.key == "Disenroll") {
        setOptionDeviceVisible(true);
      } else if (e.key == "Template") {
        setShowTemplate(true);
        opsRef.current?.opsList();
      } else if (e.key == "ClearPasscode") {
        iosDeviceOperation(deviceId, {
          commandType: 50
        }).then(() => {
          opsRef.current?.opsList();
          notification.success({ message: t("清除锁屏密码成功") });
        }, () => {
          notification.error({ message: t("清除锁屏密码失败") });
        });
      } else if (e.key == "EraseDevice") {
        setClearDeviceVisible(true);
        opsRef.current?.opsList();
      } else if (e.key == "SystemUpdate") {
        setSystemUpdateVisible(true);
        opsRef.current?.opsList();
      } else if (e.key == "RestartDevice") {
        iosDeviceOperation(deviceId, {
          commandType: 34
        }).then(() => {
          opsRef.current?.opsList();
          notification.success({ message: t("重启成功") });
        }, () => {
          notification.error({ message: t("重启失败") });
        });

      } else if (e.key == "ShutDownDevice") {
        iosDeviceOperation(deviceId, {
          commandType: 35
        }).then(() => {
          opsRef.current?.opsList();
          notification.success({ message: t("关机成功") });
        }, () => {
          notification.error({ message: t("关机失败") });
        });

      } else if (e.key == "Activationlock") {
        getDeviceBypassCode(deviceId).then(res => {
          setBypassCode(res);
          setActivationlockVisible(true);
          opsRef.current?.opsList();
        })
      } else if (e.key == "Disown") {
        disown(deviceId).then(
          () => { 
            opsRef.current?.opsList();
            notification.success({message: t("操作成功")}); 
          },
          () => { notification.error({message: t("操作失败")}) },
        )
      } else if (e.key == "Openlock") {
        openLock(data.serialNo).then(
          () => { 
            opsRef.current?.opsList();
            notification.success({message: t("操作成功")});
          },
          () => { notification.error({message: t("操作失败")}) },
        )
      } else if (e.key == "Clearlock") {
        iosDeviceOperation(deviceId, {commandType: 57}).then(
          () => { 
            opsRef.current?.opsList();
            notification.success({message: t("清除成功")}); 
          },
          () => { notification.error({message: t("清除失败")}) },
        )
      } else if (e.key == "OpenRemoteDesktop") {
        iosDeviceOperation(deviceId, {commandType: 122}).then(
          () => { 
            opsRef.current?.opsList();
            notification.success({message: t("操作成功")}); 
          },
          () => { notification.error({message: t("操作失败")}) },
        )
      } else if (e.key == "CloseRemoteDesktop") {
        iosDeviceOperation(deviceId, {commandType: 123}).then(
          () => { 
            opsRef.current?.opsList();
            notification.success({message: t("操作成功")}) 
          },
          () => { notification.error({message: t("操作失败")}) },
        )
      } else if ("openBluetooth" === e.key) {
        iosDeviceOperation(deviceId, {commandType: 62}).then(
          () => { 
            notification.success({message: t("操作成功")});
            var timer = setInterval(function () {
              getDeviceInfo(deviceId).then((res) => {
                setData(res);
                opsRef.current?.opsList();
              });
              clearInterval(timer);
            }, 3000);
          },
          () => { notification.error({message: t("操作失败")}) },
        )
      } else if ("closeBluetooth" === e.key) {
        iosDeviceOperation(deviceId, {commandType: 63}).then(
          () => { 
            notification.success({message: t("操作成功")});
            var timer = setInterval(function () {
              getDeviceInfo(deviceId).then((res) => {
                setData(res);
                opsRef.current?.opsList();
              });
              clearInterval(timer);
            }, 3000);
          },
          () => { notification.error({message: t("操作失败")}) },
        )
      } else if (e.key == "TimeZone") {
        iosDeviceOperation(deviceId, {commandType: 360}).then(
          () => { 
            opsRef.current?.opsList();
            notification.success({message: t("操作成功")}); 
          },
          () => { notification.error({message: t("操作失败")}) },
        )
      } 
    } else {
      if (e.key == 'Install' || e.key == 'UnInstall') {
        setOperationKey(e.key);
        setIsModalVisible(true);
      } else if (e.key === "Kiosk") {
        setUnInstallAppsSearch(unInstallApps);
        setSingleAppVisible(true);
      } else if (e.key === "RemoveKiosk") {
        androidDeviceOperation(deviceId, {
          operationType: "RemoveKiosk",
          packageName: '',
        }).then(() => {
          notification.success({ message: t("操作成功") });
          var timer = setInterval(function() {
            getDeviceInfo(deviceId).then((res) => { setData(res) });
            clearInterval(timer);
          }, 3000);
        })
      } else if (e.key == "Template") {
        setShowTemplate(true);
      } else if (e.key == "DisEnroll") {
        setOptionDeviceVisible(true);
      } else if (e.key == "ClearPasscode") {
        androidDeviceOperation(deviceId, {
          operationType: "ClearPassCode",
          appid: '',
        }).then(
          () => {
            notification.success({ message: t("操作成功") });
            opsRef.current?.opsList();
          }
        )
      } else if (e.key == "ShutDownDevice") {
        androidDeviceOperation(deviceId, {
          operationType: "Shutdown",
          appid: '',
        }).then(
          () => {
            notification.success({ message: t("操作成功") });
            opsRef.current?.opsList();
          }
        )
      }
      else {
        androidDeviceOperation(deviceId, {
          operationType: e.key,
          appid: '',
        }).then(
          () => {
            notification.success({ message: t("操作成功") });
          }
        )
      }
    }
  };

  const handleOk = () => {
    setIsModalVisible(false);
    var obj = form.getFieldsValue();
    if (data?.platform == "IOS" || data?.platform == "macOS") {
      var { appId, packageName } = obj;

      var commandType = 2;
      var isEnterpriseApp = false;
      if (operationKey == "Install") {
        var tmp = appId.split("&");
        isEnterpriseApp = (tmp[1] && tmp[1].includes("enterprise"));
        appId = tmp[0];
      } else if (operationKey == "UnInstall") {
        commandType = 3;
      }

      if(commandType == 2)
      {
        if(isEnterpriseApp)
        {
          installEnterprise(deviceId, appId).then(c => {
            notification.success({ message: t("操作成功") });
            opsRef.current?.opsList();
          })
        }
        else
        {
          iosDeviceOperation(deviceId, {
            commandType: commandType,
            appId: appId,
            bundleId: packageName
          }).then(
            () => {
              notification.success({ message: t("操作成功") });
              opsRef.current?.opsList();
            }
          )
        }
      }
      else if(commandType == 3)
      {
        if (data?.platform === "macOS")
        {
          macDeviceOperation(deviceId, {operationType: commandType, packageName}).then(() => {
              notification.success({ message: t("操作成功") });
              opsRef.current?.opsList();
          })
        }
        else
        {
          iosDeviceOperation(deviceId, {
            commandType: commandType,
            appId: commandType == 3 ? 0 : appId,
            bundleId: packageName
          }).then(
            () => {
              notification.success({ message: t("操作成功") });
              opsRef.current?.opsList();
            }
          )
        }
      }
      form.resetFields();
    } else {
      const { appId, packageName } = obj;
      androidDeviceOperation(deviceId, {
        operationType: operationKey,
        appid: appId,
        packageName: packageName
      }).then(
          () => {
            notification.success({ message: t("操作成功") });
            var timer = setInterval(function () {
              getDeviceInfo(deviceId).then((res) => {
                setData(res);
              });
              clearInterval(timer);
            }, 3000);
            opsRef.current?.opsList();
          }
        )
      form.resetFields();
    }
  };


  const handleMacOk = () => {
    setIsMacModalVisible(false);
    var obj = macForm.getFieldsValue();
      var { appId, appName, packageName } = obj;
      var commandType = 2;
      if (operationKey == "Install") {
        if(!appId){
          notification.warning({ message: t("请选择应用") });
          return;
        }
        const app = installApps?.find(a => a.appId === appId);
        console.log(app);
        if(app?.appType == 'AppStore')
        {
          iosDeviceOperation(deviceId, {
            commandType: commandType,
            appId: appId
          }).then(
            () => {
              notification.success({ message: t("操作成功") });
              opsRef.current?.opsList();
            }
          )
        }
        else if(app?.appType == 'EnterpriseApp')
        {
          installEnterprise(deviceId, appId).then(c => {
              notification.success({ message: t("操作成功") });
              opsRef.current?.opsList();
          })
        }
        else if(app?.appType == 'LocalApp')
        {
          macDeviceOperation(deviceId, {commandType, appId}).then(() => {
              notification.success({ message: t("操作成功") });
              opsRef.current?.opsList();
          })
        }
      } else if(operationKey == "RemoveInstallApp"){
        commandType = 3;
        console.log(appName);
        if(!appName){
          notification.warning({ message: t("请选择应用") });
          return;
        }
        const app = unInstallApps?.find(a => a.appName === appName);
        if(app != null)
        {
          macDeviceOperation(deviceId, {commandType, appName, path: app?.path}).then(() => {
              notification.success({ message: t("操作成功") });
              opsRef.current?.opsList();
          })
        }
      } else if(operationKey == "RemoveVppApp"){
        commandType = 3;
        if(!packageName){
          notification.warning({ message: t("请选择应用") });
          return;
        }
        iosDeviceOperation(deviceId, {
          commandType: commandType,
          appId: commandType == 3 ? 0 : appId,
          bundleId: packageName
        }).then(
          () => {
            notification.success({ message: t("操作成功") });
            opsRef.current?.opsList();
          }
        )
      }  
      macForm.resetFields();
  };

  const handleLoseOk = () => {
    form?.validateFields().then((res) => {
      const { phoneNumber, message } = res;
      iosDeviceOperation(deviceId, {
        commandType: 8,
        message: message,
        phoneNumber: phoneNumber
      }).then(() => {
          notification.success({ message: t("操作成功") });
          setIsLoseModaVisible(false)
          form.resetFields();
          var timer = setInterval(function () {
            getDeviceInfo(deviceId).then((res) => {
              setData(res);
            });
            clearInterval(timer);
          }, 1500);
        }, () => {
          notification.error({ message: t("操作失败") });
        }
        )
    })
  }
  const handleLoseCancel = () => {
    setIsLoseModaVisible(false);
    form.resetFields();
  };
  const handleCancel = () => {
    setIsModalVisible(false);
    form.resetFields();
  };

  const handleMacCancel = () => {
    setIsMacModalVisible(false);
    macForm.resetFields();
  };
  const rowSelection = {
    onChange(selectedRowKeys: any, selectedRows: any) {
      setSelectPackage(selectedRowKeys[0]);
    },
    onSelect(record: any, selected: any, selectedRows: any) {
    },
    onSelectAll(selected: any, selectedRows: any, changeRows: any) {
    },
  };
  const templateRowSelection = {
    onChange(selectedRowKeys: any, selectedRows: any) {
      setSelectTemplate(selectedRowKeys[0]);
    },
    onSelect(record: any, selected: any, selectedRows: any) {
    },
    onSelectAll(selected: any, selectedRows: any, changeRows: any) {
    },
  };
  const handlerIosSingle = () => {

    if (data.platform == "IOS" || data?.platform == "macOS") {
      iosDeviceOperation(deviceId, {
        commandType: 4,
        bundleId: selectPackage,
      }).then(() => {
          notification.success({ message: t("操作成功") });
          setSingleAppVisible(false);
          //setIsSingleAppMode(true);
          var timer = setInterval(function () {
            getDeviceInfo(deviceId).then((res) => {
              setData(res);
            });
            clearInterval(timer);
          }, 1500);
        }, () => {
          notification.error({ message: t("操作失败") });
        }
        )
    } else {
      setLoding(true)
      androidDeviceOperation(deviceId, {
        operationType: "Kiosk",
        packageName: selectPackage
      }).then(
          () => {
            setLoding(false)
            setSingleAppVisible(false);
            notification.success({ message: t("操作成功") });
            var timer = setInterval(function () {
              getDeviceInfo(deviceId).then((res) => {
                setData(res);
              });
              clearInterval(timer);
            }, 3000);
            opsRef.current?.opsList();
          }
        )
    }

  }
  const handleModeChange = (e: RadioChangeEvent) => {
      setAppType(e.target.value);
      var res = installApps?.filter((c: any) => {
        return c.appType == e.target.value
      });
      setCurrentInstallApps(res);
  };

  const onDelete = (id: string) => {
    deleteDevice(deviceId).then(
      () => { 
        notification.success({ message: t("已删除") }); 
        history.push("/home/devices/list")
      },
      () => { notification.error({ message: t("删除失败") }); },
    )
  }
  const getDeviceAppsData = (platform: string) => {
    if(platform === 'macOS')
    {
      getMacDeviceApps(deviceId, {
        pageIndex: 1, pageSize: 10, search: ""
      }).then(
        (res) => { setInstalledAppsCount(res.totalCount) }
      );
    }
    else{
      getDeviceApps(deviceId, {
        pageIndex: 1, pageSize: 10, search: "", appTypes: (platform == "IOS" || platform == "macOS") ? "app" : ""
      }).then(
        (res) => { setInstalledAppsCount(res.totalCount) },
        // (error) => { notification.error({message: error.message}) }
      );
    }
  };
  const getDeviceProfilesData = () => {
    getDeviceProfiles(deviceId, { pageIndex: 1, pageSize: 10 }).then(
      (res) => { setConfigFilesCount(res.totalCount) },
      (error) => { notification.error({message: error.message}) }
    )
  }

  const handleLockOk = () => {
    form?.validateFields().then((res) => {
      const { pin, message } = res;
      iosDeviceOperation(deviceId, {
        appId: 0,
        commandType: 1,
        pin: pin,
        message: message,
      }).then(
        () => {
          notification.success({ message: t("操作成功") });
          var timer = setInterval(function () {
            getDeviceInfo(deviceId).then((res) => { setData(res) });
            clearInterval(timer);
          }, 3000);
        }, 
        () => {
          notification.error({ message: t("操作失败") });
        }
      ).finally(() => {
        setIsLockVisible(false);
        form.resetFields();
      })
    })
  }

  const handleLockCancel = () => {
    setIsLockVisible(false);
    form.resetFields();
  }

  const unbindOrRestDevice = () => {
    if (data?.platform === "IOS" || data?.platform === "macOS") {
      iosDeviceDisenroll(deviceId, {commandType: 10, removeBypassCode: clearLock}).then(
        () => {
          notification.success({ message: t("操作成功") });
          var timer = setInterval(function () {
            getDeviceInfo(deviceId).then((res) => {
              window.location.reload();
              setData(res);
              opsRef.current?.opsList();
            });
            clearInterval(timer);
          }, 3000);
        }, 
        () => {
          //notification.error({ message: t("操作失败") });
        }
      ).finally(() => {
        setOptionDeviceVisible(false);
      })
    } else {
      androidDeviceOperation(deviceId, {
        operationType: resetDevice ? "Reset" : "DisEnroll",
        appid: '',
      }).then(
        () => {
          window.location.reload();
          notification.success({ message: t("操作成功") });
        },
        () => {
          notification.success({ message: t("操作失败") });
        }
      ).finally(() => {
        setOptionDeviceVisible(false);
      })
    }
  }

  return (<>
    <div>
      <div className="breadcrumbTop py-2">
        <Breadcrumb>
    
          <Breadcrumb.Item>{t("设备")}</Breadcrumb.Item>
          <Breadcrumb.Item><Link to="/home/devices/list">{t("全部设备")}</Link></Breadcrumb.Item>
          <Breadcrumb.Item>{t("设备详情")}</Breadcrumb.Item>
        </Breadcrumb>
      </div>

      <Spin spinning={false}>
        <Row style={{ width: "100%" }}>
          <div className="borderBox" style={{backgroundColor: "#F0F1F4", padding: 0}}>
            <div style={{backgroundColor: "#fff", padding: "18px 16px 5px 16px"}}>
              <Row justify="space-between" style={{height: "76px"}}>
                <Col>

                  <Row style={{height: "76px"}}>
                    <Space size={30} >
                      <Col>
                        <div>
                          {/* {data && (<img src={(data?.platform == "IOS" || data?.platform == "macOS") ? "/images/apple.png" : "/images/android.png"} alt="" width="80" />)} */}
                          {data && (
                            (data?.platform == "IOS" && data.deviceType == "Phone" && <img src={"/images/iPhoneIcon.png"} alt="" width="50"/>) ||
                            (data?.platform == "macOS" && <img src={"/images/macIcon.png"} alt="" width="70" />) ||
                            (data?.platform == "IOS" && data.deviceType == "Pad" && <img src={"/images/ipadIcon.png"} alt="" width="50" />) ||
                            (data?.platform == "Android" && <img src={"/images/androidIcon.png"} alt="" width="50" />)
                          )}
                          {!data && (<LoadingOutlined style={{ fontSize: 30 }} />)}
                        </div>
                      </Col>
                      <Col>
                        <div style={{fontWeight: 500, display: "flex", flexDirection: "column"}}>
                          {/* <div>{data?.deviceName}</div>
                          <p id="tag">
                            {data?.userName}&nbsp;&nbsp;&nbsp;
                            {data?.tags?.map(
                              (item: any, i: number) =>
                                `${item.value}${i < data.tags?.length - 1 ? "，" : ""
                                }`
                            )}
                          </p> */}
                          <span>{data?.deviceName}</span>
                          <span style={{marginTop: "7px"}}>{data?.model}</span>
                        </div>
                      </Col>
                      {data?.status !== 4 && (
                        <Col>
                          <div style={{marginTop: "-22px"}}>
                            <Button type="primary" ghost onClick={() => { 
                              deviceOps({key: "Sync"}); 
                            }}>
                              <img src="/images/icon7.svg" alt="" style={{marginTop: "-3px", marginRight: "4px"}}/> 
                              <span>{t("同步")}</span>
                            </Button>
                          </div>
                        </Col>
                      )}
                    </Space>
                  </Row>
                </Col>
                <Col>
                  <div style={{marginTop: "10px"}}>
                    {
                      (data?.status == 1 || 1 == 1) && (
                        <Popover
                          open={dropdownVisible}
                          onOpenChange={(visible) => { 
                            setDropdownVisible(visible); 
                          }}
                          trigger='click'                        
                          styles={{ body: { padding: 0,margin:0 }}}
                          content={() => (
                            <Menu
                              className="compact-menu"
                              mode="vertical"
                              selectable={false} 
                              onClick={(e) => {
                                deviceOps(e);
                                setDropdownVisible(false); 
                              }}
                              //openKeys={selectOpenKeys}
                            >
                              <Menu.Item key='Sync'>{t("同步设备")}</Menu.Item>
                              {(data?.platform == "IOS") && (
                                <Menu.Item key='Location' disabled={data?.lostModeStatus != "Enabled"}>
                                  {t("获取设备位置")}
                                  <Tooltip title={t("只适用于受监督设备")}>
                                    <Tag color="purple" style={{margin: "0 0 0 5px"}}>S</Tag>
                                  </Tooltip>
                                </Menu.Item>
                              )}
                              {(data?.platform === "IOS") && (
                                <Menu.SubMenu style={{ lineHeight: '30px' }} onTitleClick={(e) => { setSelectOpenKeys([e.key]) }} key='Bluetooth' title={t("蓝牙")}>
                                  <Menu.Item style={{minWidth:'100px'}} key='openBluetooth'>{t("打开蓝牙")}</Menu.Item>
                                  <Menu.Item style={{minWidth:'100px'}} key='closeBluetooth'>{t("关闭蓝牙")}</Menu.Item>
                                </Menu.SubMenu>
                              )}
                              {(data?.platform == "IOS" || data?.platform == "macOS") && (<Menu.Item key='TimeZone'>{t("本地时区")}</Menu.Item>)}
                              {(data?.platform == "IOS" || data?.platform == "Android") && (<Menu.Item key='ClearPasscode'>{t("清除锁屏密码")}</Menu.Item>)}
                              {data?.platform == "Android" && (<Menu.Item key='Location'>{t("获取设备位置")}</Menu.Item>)}
                              <Menu.Item key='Lock'>{t("锁定设备")}</Menu.Item>
                              {(data?.platform == "IOS" || data?.platform == "macOS") && (<Menu.Item key='EraseDevice'>{t("抹除设备")}</Menu.Item>)}
                              <Popconfirm 
                                title={t("确认重启?")} 
                                onConfirm={() => { deviceOps({key: 'RestartDevice'}) }}
                                okText={t("确认")}
                                cancelText={t("取消")}
                              >
                                {(data?.platform == "IOS" || data?.platform == "macOS") && (
                                  <Menu.Item key='RestartDevice' className="custom-menu-item">
                                    {t("重启")}
                                    <Tooltip title={t("只适用于受监督设备")}>
                                      <Tag color="purple" style={{margin: "0 0 0 5px"}}>S</Tag>
                                    </Tooltip>
                                  </Menu.Item>
                                )}
                              </Popconfirm>
                              <Popconfirm 
                                title={t("确认关机?")} 
                                onConfirm={() => { deviceOps({key: 'ShutDownDevice'}) }}
                                okText={t("确认")}
                                cancelText={t("取消")}
                              >
                                {(data?.platform == "IOS" || data?.platform == "macOS") && (
                                  <Menu.Item key='ShutDownDevice' className="custom-menu-item">
                                    {t("关机")}
                                    <Tooltip title={t("只适用于受监督设备")}>
                                      <Tag color="purple" style={{margin: "0 0 0 5px"}}>S</Tag>
                                    </Tooltip>
                                  </Menu.Item>
                                )}
                              </Popconfirm>
                              <Popconfirm 
                                title={t("确认关机?")} 
                                onConfirm={() => { deviceOps({key: 'ShutDownDevice'}) }}
                                okText={t("确认")}
                                cancelText={t("取消")}
                              >
                                {(data?.platform == "Android") && (
                                  <Menu.Item key='ShutDownDevice' className="custom-menu-item">
                                    {t("关机")}
                                  </Menu.Item>
                                )}
                              </Popconfirm>
                              {(data?.platform == "IOS") && (
                                (<Menu.SubMenu onTitleClick={(e) => { setSelectOpenKeys([e.key]) }} key='Pattern' title={t("丢失模式")}>
                                  <Menu.Item key='openLostPattern'>
                                    {t("打开丢失模式")}
                                    <Tooltip title={t("只适用于受监督设备")}>
                                      <Tag color="purple" style={{margin: "0 0 0 5px"}}>S</Tag>
                                    </Tooltip>
                                  </Menu.Item>
                                  <Menu.Item key='closeLostPattern'>
                                    {t("关闭丢失模式")}
                                    <Tooltip title={t("只适用于受监督设备")}>
                                      <Tag color="purple" style={{margin: "0 0 0 5px"}}>S</Tag>
                                    </Tooltip>
                                  </Menu.Item>
                                </Menu.SubMenu>)
                              )}
                              {(data?.platform == "IOS" || data?.platform == "macOS") && (
                                <Menu.SubMenu onTitleClick={(e) => { setSelectOpenKeys([e.key]) }} key='onLock' title={t("激活锁")}>
                                  <Menu.Item key='Openlock'>{t("打开激活锁")}</Menu.Item>
                                  <Popconfirm 
                                    title={t("确认清除激活锁?")} 
                                    onConfirm={() => { deviceOps({key: 'Clearlock'}) }}
                                    okText={t("确认")}
                                    cancelText={t("取消")}
                                  >
                                    <Menu.Item key='Clearlock' className="custom-menu-item">{t("清除激活锁")}</Menu.Item>
                                  </Popconfirm>
                                  <Menu.Item key='Activationlock'>{t("激活锁旁通码")}</Menu.Item>
                                </Menu.SubMenu>
                              )}
                              {(data?.platform == "macOS") && (
                                <Menu.SubMenu onTitleClick={(e) => { setSelectOpenKeys([e.key]) }} key='remoteDesktop' title={t("远程桌面")}>
                                  <Menu.Item key='OpenRemoteDesktop'>{t("打开远程桌面")}</Menu.Item>
                                  <Popconfirm 
                                    title={t("确认关闭远程桌面?")} 
                                    onConfirm={() => { deviceOps({key: 'CloseRemoteDesktop'}) }}
                                    okText={t("确认")}
                                    cancelText={t("取消")}
                                  >
                                    <Menu.Item key='CloseRemoteDesktop' className="custom-menu-item">{t("关闭远程桌面")}</Menu.Item>
                                  </Popconfirm>
                                </Menu.SubMenu>
                              )}
                              <Menu.Item key='Install'>{t("安装应用")}</Menu.Item>
                              {data?.platform !== "macOS" && <Menu.Item key='UnInstall'>
                                  <span>{t("卸载应用")}</span>
                                </Menu.Item>
                              }
                              {data?.platform === "macOS" && 
                                <Menu.SubMenu onTitleClick={(e) => { setSelectOpenKeys([e.key]) }} key='remoteApp' title={t("卸载应用")}>
                                  <Menu.Item key='RemoveInstallApp'>{t("已安装应用")}</Menu.Item>
                                  <Menu.Item key='RemoveVppApp'>{t("VPP应用")}</Menu.Item>
                                </Menu.SubMenu>
                              }
                              {(data?.platform === "IOS") && (
                                <Menu.SubMenu onTitleClick={(e) => { setSelectOpenKeys([e.key]) }} key='SingleAppMode' title={t("单应用模式")}>
                                  <Menu.Item key='openSingleApp'>
                                    {t("打开单应用模式")}
                                    <Tooltip title={t("只适用于受监督设备")}>
                                        <Tag color="purple" style={{margin: "0 0 0 5px"}}>S</Tag>
                                    </Tooltip>
                                  </Menu.Item>
                                  <Menu.Item key='closeSingleApp'>
                                    {t("关闭单应用模式")}
                                    <Tooltip title={t("只适用于受监督设备")}>
                                        <Tag color="purple" style={{margin: "0 0 0 5px"}}>S</Tag>
                                    </Tooltip>
                                  </Menu.Item>
                                </Menu.SubMenu>
                              )}
                              {(data?.platform === "Android") && (
                                <Menu.SubMenu onTitleClick={(e) => { setSelectOpenKeys([e.key]) }} key='SingleAppMode' title={t("单应用模式")}>
                                  <Menu.Item key='Kiosk'>
                                    {t("打开单应用模式")}
                                    <Tooltip title={t("只适用于受监督设备")}>
                                        <Tag color="purple" style={{margin: "0 0 0 5px"}}>S</Tag>
                                    </Tooltip>
                                  </Menu.Item>
                                  <Menu.Item key='RemoveKiosk'>
                                    {t("关闭单应用模式")}
                                    <Tooltip title={t("只适用于受监督设备")}>
                                        <Tag color="purple" style={{margin: "0 0 0 5px"}}>S</Tag>
                                    </Tooltip>
                                  </Menu.Item>
                                </Menu.SubMenu>
                              )}
                              {(data?.platform == "IOS" || data?.platform == "macOS") && (<Menu.Item key='SystemUpdate'>{t("系统更新")}</Menu.Item>)}
                              {(data?.platform == "IOS" || data?.platform == "macOS") && (<Menu.Item key='Disenroll' disabled={data?.lostModeStatus == "Enabled"} className="custom-menu-item">{t("解绑设备")}</Menu.Item>)}
                              {data?.platform == "Android" && (<Menu.Item key='DisEnroll' className="custom-menu-item">{t("解绑设备")}</Menu.Item>)}
                              <Popconfirm 
                                title={t("确认从ABM/ASM解绑?")} 
                                onConfirm={() => { deviceOps({key: 'Disown'}) }}
                                okText={t("确认")}
                                cancelText={t("取消")}
                              >
                                {(data?.platform == "IOS" || data?.platform == "macOS") && (
                                  <Menu.Item key='Disown' className="custom-menu-item">
                                    {t("ABM/ASM解绑")}
                                  </Menu.Item>
                                )}
                              </Popconfirm>
                            </Menu>
                          )}
                        >
                          <Button type="primary" >
                            <img src="/images/icon8.svg" alt="" style={{marginTop: "-3px", marginRight: "4px"}}/> 
                            <span>{t("操作")}</span>
                            <DownOutlined />
                          </Button>
                        </Popover>
                      )
                    } 
                    <Popconfirm
                        title={`${t("确认删除")}？`}
                        onConfirm={() => onDelete(deviceId)}
                        okText={t("确认")}
                        cancelText={t("取消")}
                    >
                      <Button style={{marginLeft: "10px"}} type="primary" danger ghost>
                        <img src="/images/deleteIcon.svg" alt="" style={{marginTop: "-3px", marginRight: "4px"}}/> 
                        <span>{t("删除")}</span>
                      </Button>
                    </Popconfirm>
                    
                  </div>
                </Col>
              </Row>
              <Divider style={{margin: "10px 0"}}/>
              <Row style={{marginTop: "19px", marginBottom: "23px", textAlign: "center", justifyContent: "space-evenly"}}>
                <Col>
                    <span>{t("设备平台")}</span>
                    <div style={{marginTop: "21px"}}>
                      {data && (<img src={(data?.platform == "IOS" || data?.platform == "macOS") ? "/images/apple.png" : "/images/android.png"} alt="" width="30" />)}
                      {!data && (<LoadingOutlined style={{ fontSize: 30 }} />)}
                    </div>
                </Col>
                <Divider type="vertical" style={{height: "auto"}}/>
                <Col>
                    <span>{t("已安装应用")}</span>
                    <div style={{marginTop: "21px"}}>
                      <b style={{fontSize: "18px"}}>{installedAppsCount}</b>
                    </div>
                </Col>
                <Divider type="vertical" style={{height: "auto"}}/>
                <Col>
                    <span>{t("设备状态")}</span>
                    <div style={{marginTop: "21px", marginLeft: "-10px"}}>
                      <Badge color={deviceStatus === 0 ? "red" : deviceStatus === 1 ? "green" : "yellow"} text={<b style={{fontSize: "18px"}}>{deviceStatus === 0 ? t("未绑定") : deviceStatus === 3 ? t("待激活") : t("已绑定")}</b>} />
                    </div>
                </Col>
                {data?.platform !== "Android" && (
                  <>
                    <Divider type="vertical" style={{height: "auto"}}/>
                    <Col>
                        <span>{t("监督模式")}</span>
                        <div style={{marginTop: "21px", marginLeft: "-10px"}}>
                          <Badge color={data?.iosDeviceInfo?.supervisedModel ? "green" : "red"} text={<b style={{fontSize: "18px"}}>{data?.iosDeviceInfo?.supervisedModel ? t("已启用") : t("未启用")}</b>} />
                        </div>
                    </Col>
                  </>
                )}
                {data?.platform === "Android" && (
                  <>
                    <Divider type="vertical" style={{height: "auto"}}/>
                    <Col>
                        <span>{t("设备拥有模式")}</span>
                        <div style={{marginTop: "21px", marginLeft: "-10px"}}>
                          <Badge color={data?.androidDeviceInfo?.isDeviceOwner ? "green" : "red"} text={<b style={{fontSize: "18px"}}>{data?.androidDeviceInfo?.isDeviceOwner ? t("已启用") : t("未启用")}</b>} />
                        </div>
                    </Col>
                  </>
                )}
                <Divider type="vertical" style={{height: "auto"}}/>
                <Col>
                    <span>{t("描述文件")}</span>
                    <div style={{marginTop: "21px"}}>
                      <b style={{fontSize: "18px"}}>{configFilesCount}</b>
                    </div>
                </Col>
                <Divider type="vertical" style={{height: "auto"}}/>
                <Col>
                    <span>{t("上次同步")}</span>
                    <div style={{marginTop: "21px", marginLeft: "-10px"}}>
                      <Badge color={data?.unSyncDay === 0 ? "green" : "yellow"} text={<b style={{fontSize: "18px"}}>{data?.unSyncDay === 0 ? t("1 天内") : `${data?.unSyncDay} ${t("天前")}`}</b>} />
                    </div>
                </Col>
              </Row>
            </div>
            <Tabs style={{background: "#F0F1F4"}} tabBarStyle={{background: "#F0F1F4", height: "73px", paddingTop: "21px", paddingBottom: "16px", paddingLeft: "24px", fontWeight: 600, marginBottom: 0}}>
              <TabPane tab={t("设备概述")} key="1">
                <DeviceDetailOverview data={data} id={deviceId}/>
              </TabPane>
              {/* <TabPane tab="设备信息" key="2">
                <DeviceDetailEnrollInfo data={data} updateTags={updateTags} />
              </TabPane> */}
              <TabPane tab={t("应用")} key="3">
                { data?.platform === 'macOS' && 
                    <MacDeviceDetailApps platform={data?.platform} id={deviceId} deviceType={data?.deviceType} />
                }
                { data?.platform !== 'macOS' && 
                    <DeviceDetailApps platform={data?.platform} id={deviceId} deviceType={data?.deviceType} />
                }
              </TabPane>
              {
                (user.account.version === "Leased")  && 
                <TabPane tab={t("租赁信息")} key="8">
                  <LeaseListPage platform={data?.platform} id={deviceId} />
                </TabPane>
              }
              
              <TabPane tab={t("证书")} key="7">
                <DeviceDetailCertificate datas={data} id={deviceId} />
              </TabPane>
              <TabPane tab={t("配置文件")} key="9">
                <DeviceDetailProfiles id={deviceId} />
              </TabPane>
              {/* <TabPane tab="安全" key="4">
                ...
              </TabPane> */}
              {data?.platform === "IOS" && (
                <TabPane tab={t("内容")} key="5">
                  <DeviceDetailContents id={deviceId} />
                </TabPane>
              )}
              {data?.platform === "IOS" && (
                <TabPane tab={t("限制")} key="20">
                  <DeviceDetailRestrictions id={deviceId} />
                </TabPane>
              )}
              <TabPane tab={t("操作历史")} key="6">
                <DeviceDetailOperations  platform={data?.platform}  id={deviceId} ref={opsRef} />
              </TabPane>
              {/* <TabPane tab={t("待执行操作")} key="6">
                <DeviceDetailPendings  platform={data?.platform}  id={deviceId} ref={opsRef} />
              </TabPane> */}
            </Tabs>
          </div>
        </Row>
      </Spin>
    </div>
    <Modal
      confirmLoading={loding}
      maskClosable={false}
      title={t("单应用模式")}
      destroyOnClose={true}
      open={isSingleAppVisible}
      onOk={() => handlerIosSingle()}
      onCancel={() => setSingleAppVisible(false)}
      okText={t("确认")}
      cancelText={t("取消")}
    >
      <Space direction="vertical" style={{ width: "100%" }}>
        <Row>
          <Col span={6}>{t("应用名称")}:</Col> <Col span={18}>   <Input.Search placeholder={t("输入查询名称")} allowClear enterButton={t("搜索")} onSearch={onSearch} /></Col>
        </Row>
        <Row >
          <Table 
            scroll={{ y: '240px' }} 
            pagination={false}
            columns={columns.map((item)=>{ 
              item.title = t(item.title)
              return item 
            })} 
            style={{ width: "100%" }} 
            dataSource={unInstallAppsSearch} 
            rowSelection={{
              type: 'radio',
              ...rowSelection,
            }} 
            rowKey={"packageName"} 
            locale={{emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty>}}
          />
        </Row>
      </Space>
    </Modal>
    <Modal
      confirmLoading={loding}
      maskClosable={false}
      title={operationKey == 'Install' ? t("安装应用") : operationKey == 'UnInstall' ? t("卸载应用") : ""}
      destroyOnClose={true}
      open={isModalVisible}
      onOk={handleOk}
      onCancel={handleCancel}
      okText={t("确认")}
      cancelText={t("取消")}
    >
      <Form
        layout="horizontal"
        form={form}
        // labelCol={{ span: 3 }}
        initialValues={{ appId: null, packageName: null }}
      >
        <Item hidden={operationKey == 'UnInstall' ? true : false} label={t("应用")} name="appId">
          <Select
            showSearch
            placeholder="Select a App"
            optionFilterProp="children"
            filterOption={(input, option: any) =>
              option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {
              Array.isArray(installApps) ?
                installApps.map(app => <Select.Option key={app.appId} value={app.appId}>
                  {app.name}</Select.Option>) : ""
            }
          </Select>
        </Item>
        <Item hidden={operationKey == 'Install' ? true : false} label={t("应用")} name="packageName">
          <Select
            showSearch
            placeholder="Select a App"
            optionFilterProp="children"
            filterOption={(input, option: any) =>
              option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {
              Array.isArray(unInstallApps) ?
                unInstallApps.map(app => (<>
                  <Select.Option 
                    key={app.packageName} 
                    value={(data.platform === "macOS" && operationKey === "UnInstall") ? app.appName + "&" + app.packageName : app.packageName}
                  >
                    {app.appName}
                  </Select.Option>
                </>)) : ""
            }
          </Select>
        </Item>

      </Form>
    </Modal>

    <Modal
      confirmLoading={loding}
      maskClosable={false}
      title={operationKey == 'Install' ? t("安装应用") : (operationKey == 'RemoveInstallApp' || operationKey == 'RemoveVppApp') ? t("卸载应用") : ""}
      destroyOnHidden={true}
      open={isMacModalVisible}
      onOk={handleMacOk}
      onCancel={handleMacCancel}
      okText={t("确认")}
      cancelText={t("取消")}
    >
      <Form
        layout="horizontal"
        form={macForm}
        // labelCol={{ span: 3 }}
        initialValues={{ appId: null, packageName: null }}
      >
        <Item hidden={(operationKey == 'RemoveInstallApp' || operationKey == 'RemoveVppApp') ? true : false}>
          <Radio.Group onChange={handleModeChange} value={appType} style={{ marginTop: 20 }}>
            <Radio.Button defaultChecked value="AppStore">{t("App Store")}</Radio.Button>
            <Radio.Button value="EnterpriseApp">{t("企业应用")}</Radio.Button>
            <Radio.Button value="LocalApp">{t("本地应用")}</Radio.Button>
          </Radio.Group>
        </Item>
        <Item hidden={(operationKey == 'RemoveInstallApp' || operationKey == 'RemoveVppApp') ? true : false} label={t("应用")} name="appId">
          <Select
            showSearch
            placeholder="Select a App"
            optionFilterProp="children"
            filterOption={(input, option: any) =>
              option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {
              Array.isArray(currentInstallApps) ?
                currentInstallApps.map(app => <Select.Option key={app.appId} value={app.appId}>
                  {app.name}</Select.Option>) : ""
            }
          </Select>
        </Item>
        
        <Item hidden={(operationKey == 'Install' || operationKey == 'RemoveVppApp') ? true : false} label={t("应用")} name="appName">
          <Select
            showSearch
            placeholder="Select a App"
            optionFilterProp="children"
            filterOption={(input, option: any) =>
              option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {
              Array.isArray(unInstallApps) ?
                unInstallApps.map(app => (<>
                  <Select.Option 
                    key={app.path} 
                    value={app.appName}
                  >
                    {app.appName}
                  </Select.Option>
                </>)) : ""
            }
          </Select>
        </Item>
        <Item hidden={(operationKey == 'Install' || operationKey == 'RemoveInstallApp') ? true : false} label={t("应用")} name="packageName">
          <Select
            showSearch
            placeholder="Select a App"
            optionFilterProp="children"
            filterOption={(input, option: any) =>
              option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {
              Array.isArray(unInstallVppApps) ?
                unInstallVppApps.map(app => (<>
                  <Select.Option 
                    key={app.packageName} 
                    value={app.packageName}
                  >
                    {app.appName}
                  </Select.Option>
                </>)) : ""
            }
          </Select>
        </Item>
      </Form>
    </Modal>
    <Modal
      confirmLoading={loding}
      maskClosable={false}
      title={t("丢失模式")}
      destroyOnClose={true}
      open={isLoseModaVisible}
      onOk={handleLoseOk}
      onCancel={handleLoseCancel}
      okText={t("确认")}
      cancelText={t("取消")}
    >
      <Form
        layout="horizontal"
        form={form}
        labelCol={{ span: 6 }}
        initialValues={{ appId: null, packageName: null }}
      >
        <Item rules={[{ required: true }]} label={t("手机号码")} name="phoneNumber">
          <Input></Input>
        </Item>
        <Item rules={[{ required: true }]} label={t("消息")} name="message">
          <TextArea rows={4}></TextArea>
        </Item>
      </Form>
    </Modal>
    {/* <Modal
      width={700}
      confirmLoading={loding}
      maskClosable={false}
      title="应用配置文件"
      destroyOnClose={true}
      visible={showTemplate}
      onOk={templateApplyClick}
      onCancel={() => { setShowTemplate(false) }}
      okText={t("确认")}
      cancelText={t("取消")}
    >
      <Space direction="vertical" style={{ width: "100%" }}>
        <Row>
          <Col span={4}>配置文件名称:</Col> <Col span={18}>   <Input.Search placeholder="输入查询名称" allowClear enterButton="搜索" onSearch={onSearchTemplate} /></Col>
        </Row>
        <Row>
          <Table columns={templateColumns} style={{ width: "100%", height: 500 ,overflow:"auto"}} dataSource={templateSearchList} rowSelection={
            {
              type: 'radio',
              ...templateRowSelection,
            }} rowKey={"id"} />
        </Row>
      </Space>
    </Modal> */}
    <Modal
      width={700}
      confirmLoading={loding}
      maskClosable={false}
      title={t("绕过激活锁")}
      destroyOnClose={true}
      open={ActivationlockVisible}
      onOk={()=>{
        setActivationlockVisible(false)
      }}
      onCancel={()=>{
        setActivationlockVisible(false)
      }}
      okText={t("确认")}
      cancelText={t("取消")}
    >   
      <p style={{ fontSize: 16, color: "#6D6D6D" }}>*{t("设备还原后重新激活时,需要输入与设备绑定的Apple ID和密码。将Apple ID位置空着,在密码位置输入绕过激活码继续激活步骤。")}{t("绕过激活码")}:</p>
      <p style={{ fontSize: 28, textAlign: "center", fontWeight: 700 }}>{bypassCode}</p>
    </Modal>
    <Modal
      width={700}
      confirmLoading={loding}
      maskClosable={false}
      destroyOnClose={true}
      title={t("抹除设备")}
      open={clearDeviceVisible}
      onOk={() => {          
        iosDeviceOperation(deviceId, {commandType: 33, removeBypassCode: clearLock, autoEnable: autoEnable}).then(
          () => { 
            notification.success({ message: t("抹除设备成功") });
          }, 
          () => { notification.error({ message: t("抹除设备失败") }) }
        ).finally(
          () => { setClearDeviceVisible(false);setClearLock(false);setAutoEnable(false); }
        )
      }}
      onCancel={() => { setClearDeviceVisible(false) }}
      okText={t("确认")}
      cancelText={t("取消")}
    >
      <p>{t("抹除设备会将设备恢复至出厂状态,所有数据将被清空。")}</p>
      <div style={{display: "flex", flexDirection: "column"}}>
        <Checkbox value={clearLock} onChange={(e) => { setClearLock(e.target.checked) }}>{t("清除激活锁")}</Checkbox>
        <span style={{fontSize: "10px", color: "gray"}}>
          <b>*</b>{t("勾选将会清除设备的激活锁")}
        </span>
      </div>
      {/* <div style={{display: "flex", flexDirection: "column"}}>
        <Checkbox value={autoEnable} 
          onChange={(e) => { setAutoEnable(e.target.checked) }}
          disabled={isDisabled}
        >{t("自动激活")}</Checkbox>
        <span style={{fontSize: "10px", color: "gray"}}>
          <b>*</b>{t("勾选此项设备抹除后将自动完成激活步骤，需要清除激活锁、iOS17以上版本并且完成注册预配置")}
        </span>
      </div> */}
    </Modal>
    <Modal
      width={700}
      confirmLoading={loding}
      maskClosable={false}
      destroyOnClose={true}
      title={t("解绑设备")}
      open={optionDeviceVisible}
      onOk={unbindOrRestDevice}
      onCancel={() => { setOptionDeviceVisible(false);setClearLock(false); }}
      okText={t("确认")}
      cancelText={t("取消")}
    >
      {(data?.platform === "IOS" || data?.platform === "macOS") && (<>
        <p>{t("解绑设备会将设备从MDM中解除管控，如需继续管控需要重新注册设备。")}</p>
        <div style={{display: "flex", flexDirection: "column"}}>
          <Checkbox value={clearLock} onChange={(e) => { setClearLock(e.target.checked) }}>{t("清除激活锁")}</Checkbox>
          <span style={{fontSize: "10px", color: "gray"}}>
            <b>*</b>{t("勾选将会清除设备的激活锁")}
          </span>
        </div>
      </>)}
      {(data?.platform == "Android") && (<>
        <p>{t("解绑后用户可以自由删除MDM App，并且脱离管控")}</p>
        <div style={{display: "flex", flexDirection: "column"}}>
          <Checkbox value={resetDevice} onChange={(e) => { setResetDevice(e.target.checked) }}>{t("还原设备")}</Checkbox>
          <span style={{fontSize: "10px", color: "gray"}}>
            <b>*</b>{t("还原设备将清除所有数据，恢复出厂模式")}
          </span>
        </div>
      </>)}
    </Modal>
    <Modal
      width={700}
      confirmLoading={loding}
      maskClosable={false}
      destroyOnClose={true}
      title={t("系统更新")}
      open={systemUpdateVisible}
      onOk={() => {          
        iosDeviceOperation(deviceId, {commandType: 72}).then(
          () => { notification.success({ message: t("操作成功") }) }, 
          () => { notification.error({ message: t("操作失败") }) }
        ).finally(
          () => { setSystemUpdateVisible(false) }
        )
      }}
      onCancel={() => { setSystemUpdateVisible(false) }}
      okText={t("确认")}
      cancelText={t("取消")}
    >
      <p>{t("系统更新将根据设备当前状况下载或安装最新版本的系统。")}</p>
    </Modal>
    <Modal
      confirmLoading={loding}
      maskClosable={false}
      title={t("锁定设备")}
      destroyOnClose={true}
      open={isLockVisible}
      onOk={handleLockOk}
      onCancel={handleLockCancel}
      okText={t("确认")}
      cancelText={t("取消")}
    >
      <Form
        layout="horizontal"
        form={form}
        labelCol={{ span: 6 }}
        initialValues={{ pin: null, message: null }}
      >
        <Item rules={[{ required: true, len: 6, message: "PIN须为6位数字" }]} label="PIN" name="pin">
          <Input></Input>
        </Item>
        <Item label="Message" name="message">
          <Input></Input>
        </Item>
      </Form>
    </Modal>
  </>);
};
